export enum FeatureEntitlements {
  Caper = 'caper',
}
